import type { ButtonHTMLAttributes } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "destructive" | "destructive-ghost" | "outline" | "ghost";
  size?: "default" | "sm" | "icon";
};

/** 项目 shadcn/ui 按钮，提供稳定的语义变体与尺寸。 */
export function Button({ className = "", variant = "default", size = "default", type = "button", ...props }: ButtonProps) {
  return <button type={type} data-slot="button" data-variant={variant} data-size={size} className={`fm-shadcn-button ${className}`.trim()} {...props} />;
}
